import { render, staticRenderFns } from "./PassWordLogin.vue?vue&type=template&id=18d9f84a&scoped=true&"
import script from "./PassWordLogin.vue?vue&type=script&lang=js&"
export * from "./PassWordLogin.vue?vue&type=script&lang=js&"
import style0 from "./PassWordLogin.vue?vue&type=style&index=0&id=18d9f84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9f84a",
  null
  
)

export default component.exports